import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statEmployeeMonthReportLocaleModule: LocaleModule = {
  name: "statEmployeeMonthReport",
  messages: { en: en, it: it },
};
